<template>
  <div class="kafkaSwitch-container">
    <div class="button">
      <el-button type="primary" @click="queryKafka">查询</el-button>
      <el-button type="success" @click="turnOn">开启</el-button>
      <el-button type="danger" @click="turnOff">关闭</el-button>
    </div>

    <div style="height:20px"></div>
    <el-table
      :data="tableData"
      height="560px"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
    >
      <el-table-column width="40"></el-table-column>
      <el-table-column label="running" prop="running" min-width="100px">
        <template slot-scope="{ row }">
          <span v-if="row.running == true">true</span>
          <span v-else-if="row.running == false">false</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="autoStartup" prop="autoStartup" min-width="100px">
        <template slot-scope="{ row }">
          <span v-if="row.autoStartup == true">true</span>
          <span v-else-if="row.autoStartup == false">false</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="containerPaused"
        prop="containerPaused"
        min-width="100px"
      >
        <template slot-scope="{ row }">
          <span v-if="row.containerPaused == true">true</span>
          <span v-else-if="row.containerPaused == false">false</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="pauseRequested"
        prop="pauseRequested"
        min-width="100px"
      >
        <template slot-scope="{ row }">
          <span v-if="row.pauseRequested == true">true</span>
          <span v-else-if="row.pauseRequested == false">false</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="groupId"
        prop="groupId"
        min-width="120"
      ></el-table-column>
      <el-table-column
        label="listenerId"
        prop="listenerId"
        min-width="240"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "KafkaSwitchManagement",
  data() {
    return {
      tableData: [],
    };
  },
  methods: {
    async queryKafka() {
      let { data: res } = await this.$axios.get("/api/kafka/listener/status");
      if (res.code == 1) {
        this.tableData = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    async turnOn() {
      let { data: res } = await this.$axios.get("/api/kafka/listener/start");
      if (res.code == 1) {
        this.$message.success(res.msg);
      } else {
        this.$message.warning(res.msg);
      }
    },
    async turnOff() {
      let { data: res } = await this.$axios.get("/api/kafka/listener/stop");
      if (res.code == 1) {
        this.$message.success(res.msg);
      } else {
        this.$message.warning(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.kafkaSwitch-container {
  height: calc(100% - 60px);
  margin: 20px;
  padding: 20px 20px 0 20px;
  background: #fff;
  .button {
    display: flex;
    width: 100%;
    height: 20%;
    justify-content: space-between;
    /deep/ .el-button {
      width: 25%;
      height: 100%;
      line-height: 100%;
      border-radius: 10px;
      font-size: 40px;
    }
  }
}
</style>
